import React from 'react';
import Ink from 'react-ink';
import { addArticleLine, setObjectItem, registerCustomerAction } from '../actions/receiptActions';
import { processFunction } from '../actions/keyFunctionActions';
import * as general from '../constants/General'
import { connect } from 'react-redux'
import * as properties from '../constants/Properties'
import * as types from '../constants/Types'
import $ from 'jquery'
import PropTypes from 'prop-types'
import { setCurrentObjectGroup, getObjectGroupList } from '../objectmanagement/actions/objectManagementActions'
import { continueObjectManagementOpen, createOrder, createReceipt } from '../kiosk/actions/kioskActions'

class ItemButton extends React.Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap(e) {
    if (e.currentTarget) {
      e.currentTarget.blur();
    }

    const { 
      addArticleLine,
      createOrder,
      processFunction,
      id,
      itemparam,
      itemtype,
      itemvalue,
      registerCustomerAction,
      createReceipt
    } = this.props;

    registerCustomerAction();

    switch (itemtype) {
      case types.BUTTON_ARTICLE:
        addArticleLine(itemvalue, 0, id);

        const lines = $('.lines');
        if (properties.scrollToBottom) {
          setTimeout(function scrollToBottom() {
            lines.scrollTop(9999);
            properties.scrollToBottom = false;
            return this;
          }, 50);
        }
        break;
      case types.BUTTON_FUNCTION:
        processFunction(parseInt(itemvalue, 10), itemparam);
        break;
      case types.BUTTON_KIOSK:
        if(this.props.posType === types.POSTYPE_ORDERKIOSK)
        {
          createOrder();
        }
        if(this.props.posType === types.POSTYPE_SALESKIOSK)
        {
          createReceipt();
        }
        break;
      default:
        break;
    }
  }

  render() {    
    const {
      color,
      fileAttachmentId,
      lines,
      itemvalue,
      text,
      invisible,
      displayMode,
      btnwidth,
      btnheight,
      btntop,
      btnleft,
      shouldBlink,
      opacity
    } = this.props;

    const divstyle = {
      width: `${btnwidth}%`,
      height: `${btnheight}%`,
      top: `${btntop}%`,
      left: `${btnleft}%`,
      position: 'absolute',
      padding: displayMode === types.DISPLAYMODE_FREEFORMAT ? '0px' : '7px'
    }

    
    let style = {
      borderLeft: `7px solid ${color}`
    };
    let itembuttonClass = 'itembutton';
    let labelClass = 'itembutton-label';
    let labelStyle = {};
    let amountClass = 'receiptamount';

    if (invisible) {
      itembuttonClass += ' itembutton-invisible';
    }

    if (opacity < 1) {
      style.opacity = opacity;
    }

    if (fileAttachmentId > 0) {
      style.borderRight = `2px solid ${color}`;
      style.borderTop = `2px solid ${color}`;
      style.borderBottom = `2px solid ${color}`;
      style.backgroundImage = `url('${general.API_URL_BUTTON_IMAGE}/${fileAttachmentId}')`;
      style.backgroundRepeat = `no-repeat`;
      style.backgroundSize = `cover`;
      style.backgroundPosition = `center`;

      labelClass += ' with-image';
      labelStyle.backgroundColor = color;

      amountClass += ' with-image';
    }

    let quantity = 0;
    lines.map((line) => {
      if (line.linetype === types.ARTICLE_LINE
        && line.itemid === parseInt(itemvalue, 10)) {
        quantity += line.quantity
      }
      return line;
    })

    if (quantity === 0) {
      quantity = ''
    }

    if (shouldBlink) {
      itembuttonClass += ' blinkItemButton';  
    }
    
    return (
      <div style={divstyle}>
        <button className={itembuttonClass} style={style} onClick={this.handleTouchTap}>
          <div className={labelClass} style={labelStyle}>{text}</div>
          <Ink />
          <div className={amountClass}>
            {quantity}
          </div>
        </button>
      </div>)
  }
}

ItemButton.propTypes = {
  id: PropTypes.number.isRequired,
  itemvalue: PropTypes.string,
  itemtype: PropTypes.number,
  itemparam: PropTypes.string,
  shouldBlink: PropTypes.bool,
  opacity: PropTypes.number,
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  btnwidth: PropTypes.number.isRequired,
  btnheight: PropTypes.number.isRequired,
  btntop: PropTypes.number.isRequired,
  btnleft: PropTypes.number.isRequired,
  posList: PropTypes.arrayOf(PropTypes.shape({
  PosId: PropTypes.number.isRequired,
  visible: PropTypes.bool,
})).isRequired,
objectgroups: PropTypes.arrayOf(PropTypes.shape({
  ObjectGroupId: PropTypes.number.isRequired
})).isRequired,
  setCurrentObjectGroup: PropTypes.func.isRequired,
  setObjectItem: PropTypes.func.isRequired,
  continueObjectManagementOpen: PropTypes.func.isRequired,
  getObjectGroupList: PropTypes.func.isRequired,
  createOrder: PropTypes.func.isRequired,
  createReceipt: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    lines: state.receiptState.receipt.lines,
    posList: state.generalState.posList,
    currentPosId: state.generalState.posId,
    selectedObjectGroupId: state.objectManagementState.selectedobjectgroup,
    objectgroups: state.objectManagementState.objectgroups,
    receiptState: state.receiptState,
    objectManagementState: state.objectManagementState,
    posType: state.generalState.posType,
  }
}

export default connect(mapStateToProps,
  {
    addArticleLine,
    processFunction,
    setCurrentObjectGroup,
    setObjectItem,
    continueObjectManagementOpen,
    getObjectGroupList,
    createOrder,
    registerCustomerAction,
    createReceipt
   })(ItemButton)



// WEBPACK FOOTER //
// src/components/ItemButton.jsx